import { PolicyRequest } from '../policy-create';

export const CANCEL_POLICY_START = 'CANCEL_POLICY_START';
export const CANCEL_POLICY_SUCCESS = 'CANCEL_POLICY_SUCCESS';
export const CANCEL_POLICY_FAILED = 'CANCEL_POLICY_FAILED';
export const CANCEL_POLICY_MODAL = 'CANCEL_POLICY_MODAL';
export const CANCEL_POLICY_REASON = 'CANCEL_POLICY_REASON';

export const CancellationReason = {
  CUSTOMER_NOT_TRAVELLING: 'CUSTOMER_NOT_TRAVELLING',
  INSURANCE_NOT_NEEDED: 'INSURANCE_NOT_NEEDED',
  INCORRECT_COVERAGE: 'INCORRECT_COVERAGE',
  INCORRECT_PAYMENT: 'INCORRECT_PAYMENT',
  DUPLICATE_POLICY: 'DUPLICATE_POLICY',
  EXCEPTION: 'EXCEPTION',
  CHARGE_BACK: 'CHARGE_BACK',
  OTHER: 'OTHER',
  PREMIUM_TOO_HIGH: 'PREMIUM_TOO_HIGH',
  POLICY_RESCIND: 'POLICY_RESCIND',
  SYSTEM_LIMITATION: 'SYSTEM_LIMITATION'
};

export interface PolicyCancelPax {
  policyNumber: string;
  payment?: PaymentRequest[];
}
export interface PolicyCancelRequest {
  cancellationReason?: string;
  paxes?: PolicyCancelPax[];
}
export interface PolicyCancelStore {
  cancellationReason?: string;
  cancelPending?: boolean;
  response?: PolicyRequest;
  error?: unknown;
  showRefund?: boolean;
}
